import React from "react";
import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearchPlus,
} from "@fortawesome/free-solid-svg-icons";
import { Box, Button, useMediaQuery } from "@mui/material";
import json2mq from "json2mq";
import { shortQueries } from "../queries";

export const MeasurItPanZoomTour = (props) => {
  const short = useMediaQuery(json2mq(shortQueries));

  const textStyle = {
    fontFamily: "'Open Sans', sans-serif",
    fontSize: short ? 14 : 16,
  };

  return (
    <div style={textStyle}>
      <img
        src="/Measureit-logo.png"
        alt="measureit-welcome"
        style={{ height: 40 }}
      />
      <p style={short ? { width: 225, fontSize: 14 } : {}}>
        Drag the map using your fingers or cursor and use the zoom tools{" "}
        {<FontAwesomeIcon icon={faSearchPlus} />} to position your property. Click start to begin estimating.
      </p>
      {short ? null : (
        <img
          src="/measurit-pan-zoom.gif"
          alt="animate pan zoom"
          style={{ width: 300 }}
        />
      )}

      <Box sx={{ textAlign: "right" }}>
        <Button variant="contained" onClick={() => props.closeTour(false)}>
          Start
        </Button>
      </Box>
    </div>
  );
};

MeasurItPanZoomTour.propTypes = {
  closeTour: PropTypes.func.isRequired,
};
